import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
import { showSuccessToast } from '../../app/utils/tostify';
// import { t } from "i18next";
// import { showSuccessToast } from "../../app/utils/tostify";
import {
	getAttributesList,
	updateAttributesList,
	addAttributesList,
	getAttributesSetsList,
	addAttributesSetsList,
	updateAttributesSetsList,
	getPriceList,
	deletePrice,
	updateStatus,
	addPriceList,
	updatePriceList,
	getAssociatedList,
	getUnitsList,
	getBrandList,
	getAttributesListMore,
	getAssociatedListMore,
	deleteBrand,
	deleteUnit,
	updateBrandList,
	updateUnitsList,
	addBrandList,
	addUnitsList,
	updateAssociatedList
} from '../apis/masterDataAPIs';

interface masterState {
	error: any;
	loading: boolean;
	attrSetsloading: boolean;
	priceListloading: boolean;
	brandsloading: boolean;
	uomloading: boolean;
	priceList: Array<any>;
	attributesList: Array<any>;
	attributesListMore: Array<any>;
	attributesSetsList: Array<any>;
	attrAssociatedList: Array<any>;
	attrAssociatedListMore: Array<any>;
	priceLists: Array<any>;
	selectedAttributesList: Array<any>;
	currentPage: number;
	count: number;
	attributesSetsListCount: number;
	attrAssociatedListcount: number;
	priceListCount: number;
	attributesListcount: number;
	customerDetails: any;
	deviceList: any;
	unitsList: Array<any>;
	brandList: Array<any>;
}

const initialState: masterState = {
	loading: false,
	attrSetsloading: false,
	priceListloading: false,
	brandsloading: false,
	uomloading: false,
	error: [],
	priceList: [],
	selectedAttributesList: [],
	attributesList: [],
	attributesSetsList: [],
	attrAssociatedList: [],
	priceLists: [],
	currentPage: 1,
	count: 0,
	attributesSetsListCount: 0,
	attrAssociatedListcount: 0,
	attributesListcount: 0,
	priceListCount: 0,
	customerDetails: {},
	deviceList: [],
	unitsList: [],
	brandList: [],
	attributesListMore: [],
	attrAssociatedListMore: []
};

const masterdataSlice = createSlice({
	name: 'masterdataSlice',
	initialState,
	reducers: {
		handlePaginationInAttributes(state, action: any) {
			state.currentPage = action.payload;
		},
		addAttributesList(state, action: any) {
			state.selectedAttributesList = [];
			state.selectedAttributesList.push(action.payload);
			// console.log(action.payload.message, "payload");
			showSuccess({ message: t(action.payload.message) });
		},
		removeImagesList(state, action: any) {
			state.selectedAttributesList.splice(action.payload, 1);
		},
		removeAssociatedData(state) {
			state.attrAssociatedListMore = [];
			state.attributesListMore = [];
		}
	},
	extraReducers: (builder) => {
		// common for status update
		builder.addCase(updateStatus.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateStatus.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateStatus.rejected, (state: masterState) => {
			state.loading = false;
		});

		// Attribute
		builder.addCase(getAttributesList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
			state.customerDetails = {};
		});
		builder.addCase(
			getAttributesList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.attributesList = action?.payload?.data?.list;
				state.attributesListcount = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(
			getAttributesListMore.fulfilled,
			(state: masterState, action: any) => {
				state.attributesListMore = !action.payload.data.list.some(
					(item: any) =>
						state.attributesListMore.some(
							(itemx: any) => itemx._id == item._id
						)
				)
					? [...state.attributesListMore, ...action.payload.data.list]
					: [...state.attributesListMore];
				state.attributesListcount = action?.payload?.data?.count;
			}
		);
		builder.addCase(getAttributesList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(updateAttributesList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateAttributesList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateAttributesList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(addAttributesList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addAttributesList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addAttributesList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(addBrandList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addBrandList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addBrandList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(addUnitsList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addUnitsList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addUnitsList.rejected, (state: masterState) => {
			state.loading = false;
		});
		// builder.addCase(deleteImageList.pending, (state: masterState) => {
		//     state.loading = true;
		//     state.error = "";
		//   });
		//   builder.addCase(deleteImageList.fulfilled, (state: masterState, action: any) => {
		//     state.loading = false;
		//     state.error = "";
		//     showSuccessToast({ message: t(action?.payload?.message) })
		//   });
		//   builder.addCase(deleteImageList.rejected, (state: masterState) => {
		//     state.loading = false;
		//   });

		// Attributes sets
		builder.addCase(getAttributesSetsList.pending, (state: masterState) => {
			state.attrSetsloading = true;
			state.error = '';
		});
		builder.addCase(
			getAttributesSetsList.fulfilled,
			(state: masterState, action: any) => {
				state.attrSetsloading = false;
				state.attributesSetsList = action?.payload?.data?.list;
				state.attributesSetsListCount = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(
			getAttributesSetsList.rejected,
			(state: masterState) => {
				state.attrSetsloading = false;
			}
		);
		builder.addCase(addAttributesSetsList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addAttributesSetsList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			addAttributesSetsList.rejected,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = action.payload.message;
			}
		);

		builder.addCase(
			updateAttributesSetsList.pending,
			(state: masterState) => {
				state.loading = true;
				state.error = '';
			}
		);
		builder.addCase(
			updateAttributesSetsList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			updateAttributesSetsList.rejected,
			(state: masterState) => {
				state.loading = false;
			}
		);
		builder.addCase(getAssociatedList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			getAssociatedList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.attrAssociatedList = action?.payload?.data?.list;
				state.attrAssociatedListcount = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(getAssociatedList.rejected, (state: masterState) => {
			state.attrAssociatedList = [];
			state.loading = false;
		});
		builder.addCase(
			getAssociatedListMore.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.attrAssociatedListMore = !action.payload.data.list.some(
					(item: any) =>
						state.attrAssociatedListMore.some(
							(itemx: any) => itemx._id == item._id
						)
				)
					? [
							...state.attrAssociatedListMore,
							...action.payload.data.list
					  ]
					: [...state.attrAssociatedListMore];
				state.attrAssociatedListcount = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(
			getAssociatedListMore.rejected,
			(state: masterState) => {
				state.loading = false;
				state.attrAssociatedListMore = [];
				state.attrAssociatedListcount = 0;
			}
		);
		builder.addCase(updateAssociatedList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateAssociatedList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateAssociatedList.rejected, (state: masterState) => {
			state.loading = false;
		});

		//unit list
		builder.addCase(getUnitsList.pending, (state: masterState) => {
			state.uomloading = true;
			state.error = '';
			state.customerDetails = {};
		});
		builder.addCase(
			getUnitsList.fulfilled,
			(state: masterState, action: any) => {
				state.uomloading = false;
				state.unitsList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.deviceList = [];
				state.error = '';
			}
		);
		builder.addCase(getUnitsList.rejected, (state: masterState) => {
			state.uomloading = false;
		});
		//bnradList
		builder.addCase(getBrandList.pending, (state: masterState) => {
			state.brandsloading = true;
			state.error = '';
			state.customerDetails = {};
		});
		builder.addCase(
			getBrandList.fulfilled,
			(state: masterState, action: any) => {
				state.brandsloading = false;
				state.brandList = action?.payload?.data?.list;
				state.count = action?.payload?.data?.count;
				state.deviceList = [];
				state.error = '';
			}
		);
		builder.addCase(getBrandList.rejected, (state: masterState) => {
			state.brandsloading = false;
		});
		// Price List
		builder.addCase(getPriceList.pending, (state: masterState) => {
			state.priceListloading = true;
			state.error = '';
		});
		builder.addCase(
			getPriceList.fulfilled,
			(state: masterState, action: any) => {
				state.priceListloading = false;
				state.priceLists = action?.payload?.data?.list;
				state.priceListCount = action?.payload?.data?.count;
				state.error = '';
			}
		);
		builder.addCase(getPriceList.rejected, (state: masterState) => {
			state.priceListloading = false;
		});
		builder.addCase(addPriceList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addPriceList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addPriceList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(updatePriceList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updatePriceList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updatePriceList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(updateBrandList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateBrandList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateBrandList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(updateUnitsList.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateUnitsList.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateUnitsList.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(deletePrice.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deletePrice.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(deletePrice.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(deleteBrand.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deleteBrand.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(deleteBrand.rejected, (state: masterState) => {
			state.loading = false;
		});
		builder.addCase(deleteUnit.pending, (state: masterState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deleteUnit.fulfilled,
			(state: masterState, action: any) => {
				state.loading = false;
				state.error = '';
				showSuccessToast({ message: t(action?.payload?.message) });
			}
		);
		builder.addCase(deleteUnit.rejected, (state: masterState) => {
			state.loading = false;
		});
	}
});

export const { handlePaginationInAttributes, removeAssociatedData } =
	masterdataSlice.actions;
export default masterdataSlice.reducer;
